<mat-expansion-panel #trifoldExpPanel [(expanded)]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <a class="icon-link" (click)="onItemEvent($event, closeTrifold)" matTooltip="Close Item"><mat-icon>close_small</mat-icon></a>
    </mat-panel-title>
    <mat-panel-description>
      @if (item.state!.expanded && canAccessAnyTrifolds) {
        <a class="icon-link" (click)="onToggleIpDetails($event, item)" [matTooltip]="currentView === 'detail' ? 'View Trifold' : 'View Detail'">
          @if (currentView === 'detail') {
            <mat-icon>switch_left</mat-icon>
          }
          @if (currentView === 'trifold') {
            <mat-icon>switch_right</mat-icon>
          }
        </a>
      }
      <a class="icon-link" (click)="onItemEvent($event, favorite)" [matTooltip]="item.favorite ? 'Select To Remove Favorite' : 'Select To Add Favorite'">
        @if (item.favorite) {
          <mat-icon>star</mat-icon>
        } @else {
          <mat-icon>star_outline</mat-icon>
        }
      </a>
      <a class="icon-link" [matMenuTriggerFor]="familyCases" (menuOpened)="onFamilyCasesMenuOpened()" (click)="$event.stopPropagation()" matTooltip="Family Cases">
        <mat-icon>account_tree</mat-icon>
      </a>
      <mat-menu #familyCases="matMenu" class="family-cases-menu">
        @if (familyCaseItems.length > 0) {
          <div class="family-case-items" [class.paginated]="totalFamilyCaseCount > FAMILY_CASE_LIMIT">
            @for (familyCase of familyCaseItems; track familyCase.identifier) {
              <button mat-menu-item (click)="onFamilyCaseClick(familyCase)">
                <ip-icon [ipType]="familyCase.ipType"></ip-icon>
                <span class="family-case-name">{{ familyCase.identifier }}</span>
              </button>
            }
          </div>
          @if (totalFamilyCaseCount > FAMILY_CASE_LIMIT) {
            <div class="family-case-pagination">
              <button mat-icon-button [disabled]="!canGoPreviousFamilyCase" (click)="previousFamilyCasePage($event)">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <span class="family-case-page-info">{{ familyCaseStartIndex + 1 }}-{{ familyCaseEndIndex }} of {{ totalFamilyCaseCount }}</span>
              <button mat-icon-button [disabled]="!canGoNextFamilyCase" (click)="nextFamilyCasePage($event)">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          }
        } @else {
          <button mat-menu-item disabled="">
            <span>None</span>
          </button>
        }
      </mat-menu>
      @if (canUploadAnyTrifolds) {
        <a class="icon-link" (click)="uploadIncludeFileBrowse? uploader.click() : onItemUploadEvent($event)" matTooltip="Upload"><mat-icon>upload</mat-icon></a>
      }
      <input hidden="hidden" multiple="multiple" type="file" #uploader (change)="onBrowseFiles($event)" />
      @if (isFeatureEnabled('openInIpms') && item.caseUrl) {
        <a class="icon-link" (click)="onItemEvent($event, openIPMS)" matTooltip="Open in IPMS">
          <mat-icon>open_in_new</mat-icon>
        </a>
      }
      @if (item.state!.expanded && canAccessAnyTrifolds && currentView === 'trifold') {
        <a class="icon-link" (click)="onToggleFilter($event)" matTooltip="Toggle Filter">
          @if (!isFilterVisible) {
            <mat-icon fontSet="material-icons-outlined">filter_alt</mat-icon>
          }
          @if (isFilterVisible) {
            <mat-icon>filter_alt</mat-icon>
          }
        </a>
      }
      @if (item.state!.expanded) {
        <a class="icon-link" (click)="onItemEvent($event, refresh)" matTooltip="Refresh"><mat-icon>refresh</mat-icon></a>
      }
    </mat-panel-description>
    <div class="case-number-row">
      <ip-icon [ipType]="item.ipType"></ip-icon>
      <a class="case-number" (click)="onItemEvent($event, openFTF)" [matTooltip]="'Open &quot;' + item.identifier + '&quot; In First to File'">{{item.identifier}}</a>
    </div>
  </mat-expansion-panel-header>
  <div class="content-container">
    @if (overlayDetail) {
      <div class="overlay-container">
        <ip-detail [detail]="overlayDetail" [title]="overlayDetail.title" (closed)="onOverlayDetailsClose()"></ip-detail>
      </div>
    }
    @if (!overlayDetail && selectionMode) {
      <div class="selection-container">
        <span>{{ selectionModel.selected.length }} selected</span>
        <div class="menu-container">
          <a class="icon-link" matTooltip="Clear Selection" (click)="onClearSelection()">
            <mat-icon>close_small</mat-icon>
          </a>
          <a class="icon-link" matTooltip="Actions" #trigger=matMenuTrigger
            [matMenuTriggerFor]="selectionMenu" [matMenuTriggerData]="{ selectionModel }">
            <mat-icon>more_vert</mat-icon>
          </a>
          <mat-menu #selectionMenu="matMenu">
            <button mat-menu-item (click)="onClearSelection()">Clear Selection</button>
            @if (isFeatureEnabled('documentSendToAction') && widgetProductName) {
              <button mat-menu-item (click)="onItemSelectionEvent($event, selectionModel.selected, widget, false)">Send To {{widgetProductName}}</button>
            }
          </mat-menu>
        </div>
      </div>
    }
    @if (orientation === 'Vertical') {
      <div [class.hidden]="overlayDetail || (currentView === 'trifold' && canAccessAnyTrifolds) || !item.detail" class="detail-container">
        @if (item.detail) {
          <mat-tab-group [animationDuration]="tabAnimationDuration" mat-stretch-tabs="true" disablePagination="true" [(selectedIndex)]="selectedDetailIndex">
            @for (tabType of detailTabs; track tabType) {
              @switch (tabType) {
                <!-- References Tab -->
                @case ('references') {
                  <mat-tab label="Ref." labelClass="reference">
                    <ng-container [ngTemplateOutlet]="referencesTabContent" [ngTemplateOutletContext]="{ item: item }"></ng-container>
                  </mat-tab>
                }
                <!-- Workflows Tab -->
                @case ('workflow') {
                  <mat-tab label="Workflows" labelClass="workflow">
                    <ng-container [ngTemplateOutlet]="workflowTabContent" [ngTemplateOutletContext]="{ item: item }"></ng-container>
                  </mat-tab>
                }
                <!-- Notes Tab -->
                @case ('notes') {
                  <mat-tab label="Notes" labelClass="note">
                    <ng-container [ngTemplateOutlet]="notesTabContent" [ngTemplateOutletContext]="{ item: item }"></ng-container>
                  </mat-tab>
                }
                <!-- Details Tab -->
                @case ('biblio') {
                  @if (getDisplayableBiblio(item); as biblio) {
                    <mat-tab label="Details" labelClass="detail">
                      <ng-container [ngTemplateOutlet]="biblioTabContent" [ngTemplateOutletContext]="{ item: item, trademarkThumbnail: trademarkThumbnail, biblio: biblio }"></ng-container>
                    </mat-tab>
                  }
                }
              }
            }
          </mat-tab-group>
        }
      </div>
    }
    @if (orientation === 'Vertical') {
      <div [class.hidden]="overlayDetail || currentView === 'detail' || !canAccessAnyTrifolds" class="trifold-container">
        <div class="filters-container" [class.hidden]="!isFilterVisible">
          <mat-form-field appearance="outline" class="trifold-filter ">
            <mat-label>Title / Filename / Doc Sub-Type</mat-label>
            <input matInput [formControl]="searchControl"/>
            <button matSuffix mat-icon-button aria-label="Clear" (click)="onClearFilters($event)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <a class="icon-link" (click)="onMoreFiltersClick($event)" matTooltip="More Filters" [matBadgeHidden]="filterCount === 0" [matBadge]="filterCount" matBadgeSize="small">
            <mat-icon>tune</mat-icon>
          </a>
        </div>
        <div class="trifold-tab-container">
          <mat-tab-group [animationDuration]="tabAnimationDuration" mat-stretch-tabs="true" disablePagination="true"
            [(selectedIndex)]="selectedTrifoldIndex">
            @for (trifold of trifoldOrder; track trackByTrifold($index, trifold)) {
              @if (trifoldMap[item.ipType][trifold]; as trifoldDetail) {
                @if (trifoldDetail.access) {
                  <mat-tab label="{{trifoldDetail.label}}">
                    @if (filteredDocs$ | async; as docsByTrifold) {
                      @if (docsByTrifold[trifold]; as docs) {
                        <ng-container [ngTemplateOutlet]="trifoldDocsTabContent"
                        [ngTemplateOutletContext]="{ trifold: trifold, trifoldDetail: trifoldDetail, docs: docs }"></ng-container>
                      }
                    }
                  </mat-tab>
                }
              }
            }
          </mat-tab-group>
        </div>
      </div>
    }

    @if (orientation !== 'Vertical') {
      <div
        [class.hidden]="overlayDetail || (currentView === 'trifold' && canAccessAnyTrifolds) || !item.detail"
        class="detail-container horizontal-layout">
        @for (tabType of detailTabs; track tabType; let last = $last; let i = $index) {
          <ng-container class="detail-section">
            @switch (tabType) {
              @case ('references') {
                <div class="detail-section">
                  <div class="mat-title-small">References</div>
                  <ng-container [ngTemplateOutlet]="referencesTabContent" [ngTemplateOutletContext]="{ item: item }"></ng-container>
                </div>
              }
              @case ('workflow') {
                <div class="detail-section">
                  <div class="mat-title-small">Workflows</div>
                  <ng-container [ngTemplateOutlet]="workflowTabContent" [ngTemplateOutletContext]="{ item: item }"></ng-container>
                </div>
              }
              @case ('notes') {
                <div class="detail-section">
                  <div class="mat-title-small">Notes</div>
                  <ng-container [ngTemplateOutlet]="notesTabContent" [ngTemplateOutletContext]="{ item: item }"></ng-container>
                </div>
              }
              @case ('biblio') {
                <div class="detail-section">
                  @if (getDisplayableBiblio(item); as biblio) {
                    <div>
                      <div class="mat-title-small">Details</div>
                      <ng-container [ngTemplateOutlet]="biblioTabContent" [ngTemplateOutletContext]="{ item: item, trademarkThumbnail: trademarkThumbnail, biblio: biblio }"></ng-container>
                    </div>
                  }
                </div>
              }
            }
            @if (!last) {
              <hr />
            }
          </ng-container>
        }
      </div>
    }

    @if (orientation !== 'Vertical') {
      <div [class.hidden]="overlayDetail || currentView === 'detail' || !canAccessAnyTrifolds" class="trifold-container">
        <div class="filters-container" [class.hidden]="!isFilterVisible">
          <mat-form-field appearance="outline" class="trifold-filter ">
            <mat-label>Title / Filename / Doc Sub-Type</mat-label>
            <input matInput [formControl]="searchControl"/>
            <button matSuffix mat-icon-button aria-label="Clear" (click)="onClearFilters($event)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <a class="icon-link" (click)="onMoreFiltersClick($event)" matTooltip="More Filters" [matBadgeHidden]="filterCount === 0" [matBadge]="filterCount" matBadgeSize="small">
            <mat-icon>tune</mat-icon>
          </a>
        </div>
        <div class="trifold-tab-container horizontal-trifold-list">
          <div class="horizontal-trifold-sections">
            @if (filteredDocs$ | async; as docsByTrifold) {
              @for (trifold of trifoldOrder; track trackByTrifold(i, trifold); let last = $last; let i = $index) {
                @if (trifoldMap[item.ipType][trifold]; as trifoldDetail) {
                  @if (trifoldDetail.access) {
                    <div class="trifold-section">
                      <div class="mat-title-small trifold-section-title">{{ trifoldDetail.label }}</div>
                      @if (docsByTrifold[trifold]; as docs) {
                        <ng-container [ngTemplateOutlet]="trifoldDocsTabContent"
                        [ngTemplateOutletContext]="{ trifold: trifold, trifoldDetail: trifoldDetail, docs: docs }"></ng-container>
                      }
                    </div>
                  }
                  @if (!last && trifoldDetail.access) {
                    <hr />
                  }
                }
              }
            }
          </div>
        </div>
      </div>
    }

  </div>
</mat-expansion-panel>

<ng-template #referencesTabContent let-item="item">
  <searchable [data]="item.detail.references || []" [filterCallback]="filterReferences" label="Reference Name / Type">
    <ng-template let-references$>
      <mat-list>
        <mat-list-item *ngFor="let ref of references$ | async; trackBy: trackByDoc">
          @if (selectionMode) {
            <mat-checkbox matListItemIcon
              [checked]="selectionModel.isSelected({ type: 'reference', doc: ref })"
            (change)="toggleSelection({ type: 'reference', doc: ref })"></mat-checkbox>
          }
          <span matLine matListItemTitle matTooltip="{{ ref.titleDisplay }}">
            <img class="doc-icon" [attr.src]="'assets/doc-icons/icon-' + getRefDocIcon(ref) + '.png'"
              alt="icon" (click)="getDocumentAction(ref, 'icon', 'refDetails', 'reference')($event)" />
            <span (click)="getDocumentAction(ref, 'text', 'refDetails', 'reference')($event)">
              {{ ref.titleDisplay }}
            </span>
          </span>
          <span class="doc-details">{{ ref.referenceTypeDisplay }}</span>
          <a class="icon-link" matListItemMeta matTooltip="Actions" #trigger=matMenuTrigger
            [matMenuTriggerFor]="refMenu" [matMenuTriggerData]="{ ref }">
            <mat-icon>more_vert</mat-icon>
          </a>
        </mat-list-item>
      </mat-list>
      <mat-menu #refMenu="matMenu">
        <ng-template matMenuContent let-ref="ref">
          @if (isFeatureEnabled('documentDownload')) {
            <button mat-menu-item
            (click)="onItemFileEvent($event, 'reference', ref, download, false)">Download</button>
          }
          @if (isFeatureEnabled('documentPreview')) {
            <button mat-menu-item
            (click)="onItemFilePreviewEvent($event, 'reference', ref, pdfPreview, false)">Preview</button>
          }
          <button mat-menu-item
          (click)="onOverlayDetailsOpen($event, 'refDetails', ref, false)">Details</button>
          @if (attachActions) {
            <button mat-menu-item
            (click)="onItemFileEvent($event, 'reference', ref, attach, false)">Attach To Email</button>
          }
          @if (isFeatureEnabled('documentSendToAction') && widgetProductName) {
            <button mat-menu-item
              (click)="onItemSelectionEvent($event, [{ type: 'reference', doc: ref }], widget, false)">Send To
            {{widgetProductName}}</button>
          }
        </ng-template>
      </mat-menu>
    </ng-template>
  </searchable>
</ng-template>

<ng-template #workflowTabContent let-item="item">
  <searchable [data]="item.detail.workflow" [filterCallback]="filterWorkflows" label="Workflow / Task / Assignee">
    <ng-template let-workflows$>
      <workflow-detail *ngFor="let wf of workflows$ | async; trackBy: trackById" [item]="item" [workflow]="wf"
        [menu]="wfMenu" (workflowChange)="onItemWorkflowEvent($event)"
        (docEvent)="getWorkflowAction($event.record, $event.actionType)()"></workflow-detail>
      <mat-menu #wfMenu="matMenu">
        <ng-template matMenuContent let-doc="doc">
          @if (isFeatureEnabled('documentDownload')) {
            <button mat-menu-item
            (click)="onItemFileEvent($event, doc.type === 'Reference' ? 'reference' : 'trifold', doc.raw, download, false)">Download</button>
          }
          @if (isFeatureEnabled('documentPreview')) {
            <button mat-menu-item
            (click)="onItemFilePreviewEvent($event, doc.type === 'Reference' ? 'reference' : 'trifold', doc.raw, pdfPreview, false)">Preview</button>
          }
          <button mat-menu-item
          (click)="onOverlayDetailsOpen($event, doc.type === 'Reference' ? 'refDetails' : 'docDetails', doc.raw, false)">Details</button>
          @if (attachActions) {
            <button mat-menu-item
              (click)="onItemFileEvent($event, doc.type === 'Reference' ? 'reference' : 'trifold', doc.raw, attach, false)">Attach
            To Email</button>
          }
        </ng-template>
      </mat-menu>
    </ng-template>
  </searchable>
</ng-template>

<ng-template #notesTabContent let-item="item">
  <searchable [data]="item.detail.notes" [filterCallback]="filterNotes" label="Note / User">
    <ng-template let-notes$>
      <mat-card *ngFor="let note of notes$ | async" appearance="outlined">
        <mat-card-header>
          <mat-card-title>{{note.createByUser}}</mat-card-title>
          <mat-card-subtitle>{{note.createDate | date : 'dd-MMM-yyyy HH:mm:ss' }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p [innerHTML]="getFormattedNote(note)"></p>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </searchable>
</ng-template>

<ng-template #biblioTabContent let-biblio="biblio" let-item="item" let-trademarkThumbnail="trademarkThumbnail">
  <ip-detail [detail]="biblio">
    @if (trademarkThumbnail) {
      <div class="detail-row">
        <div class="detail-label">Depiction of Mark</div>
        <div class="detail-value">
          <img src="{{trademarkThumbnail.data}}" class="detail-thumbnail" />
        </div>
      </div>
    }
  </ip-detail>
</ng-template>

<ng-template #trifoldDocsTabContent let-trifold="trifold" let-trifoldDetail="trifoldDetail" let-docs="docs">
  <ng-template mat-tab-label>
    <label [matTooltip]="trifoldDetail.label">{{ isFilterSet ? '(' + docs.length + ') ' : '' }}{{
    trifoldDetail.label }}</label>
  </ng-template>
  @if (docs.length === 0) {
    <p class="no-results">{{ isFilterSet ? 'No files found' : 'No files available' }}</p>
  }
  <mat-list>
    @for (doc of docs | trifoldSort:sortCriteria; track trackByDoc($index, doc)) {
      <mat-list-item
        (mouseenter)="onTrifoldDocHover(doc, trifold || '')">
        @if (selectionMode) {
          <mat-checkbox matListItemIcon
            [checked]="selectionModel.isSelected({ type: 'trifold', doc })"
          (change)="toggleSelection({ type: 'trifold', doc })"></mat-checkbox>
        }
        <span matLine matListItemTitle matTooltip="{{ doc.title || doc.fileName }}">
          <span class="file-title">
            <img class="doc-icon" [attr.src]="'assets/doc-icons/icon-' + getTrifoldDocIcon(doc) + '.png'"
              alt="icon" (click)="getDocumentAction(doc, 'icon')($event)" />
            @if (doc.status === 'Locked') {
              <img class="doc-icon secondary" src="assets/doc-icons/icon-lock.png"
                alt="icon" (click)="getDocumentAction(doc, 'icon')($event)" />
            }
            @if (doc.status === 'Checked-Out') {
              <img class="doc-icon secondary"
                src="assets/doc-icons/icon-pencil.png" alt="icon" />
            }
            <span (click)="getDocumentAction(doc, 'text')($event)">
              {{ doc.title || doc.fileName }}
            </span>
          </span>
        </span>
        <span class="doc-details">
          {{ getTrifoldDocDetailString(doc) }}
        </span>
        <a class="icon-link" matListItemMeta matTooltip="Actions" #trigger=matMenuTrigger
          [matMenuTriggerFor]="docMenu" [matMenuTriggerData]="{ doc }">
          <mat-icon>more_vert</mat-icon>
        </a>
      </mat-list-item>
    }
  </mat-list>
  <mat-menu #docMenu="matMenu">
    <ng-template matMenuContent let-doc="doc">
      @if (isFeatureEnabled('documentDownload')) {
        <button mat-menu-item (click)="onItemFileEvent($event, 'trifold', doc, download, false)">Download</button>
      }
      <button mat-menu-item (click)="onOpenShareLinkDialog(doc)">Share Link</button>
      @if (isFeatureEnabled('documentPreview')) {
        <button mat-menu-item (click)="onItemFileEvent($event, 'trifold', doc, pdfPreview, false)">Preview</button>
      }
      <button mat-menu-item (click)="onOverlayDetailsOpen($event, 'docDetails', doc, false)">Details</button>
      @if (isFeatureEnabled('documentChangeStatus')) {
        @switch (doc.status) {
          @case ('Checked-Out') {
            @if (trifoldDetail.version) {
              <button mat-menu-item
              (click)="onItemFileEvent($event, 'trifold', doc, undoCheckout, false)">Undo Check-out</button>
            }
          }
          @case ('Locked') {
            @if (trifoldDetail.lock) {
              <button mat-menu-item
              (click)="onItemFileEvent($event, 'trifold', doc, unlock, false)">Unlock</button>
            }
          }
          @default {
            @if (trifoldDetail.version) {
              <button mat-menu-item
              (click)="onItemFileEvent($event, 'trifold', doc, checkout, false)">Check-out</button>
            }
            @if (trifoldDetail.lock) {
              <button mat-menu-item
              (click)="onItemFileEvent($event, 'trifold', doc, lock, false)">Lock</button>
            }
          }
        }
      }
      @if (isFeatureEnabled('upload') && canUploadNewVersion && trifoldDetail.version && canUploadNewVersion(doc) && !isExportControlled(doc)) {
        <button mat-menu-item
        (click)="onItemFileEvent($event, 'trifold', doc, uploadVersion, false)">Upload New Version</button>
      }
      @if (attachActions) {
        <button mat-menu-item
        (click)="onItemFileEvent($event, 'trifold', doc, attach, false)">Attach To Email</button>
      }
      @if (isFeatureEnabled('documentSendToAction') && widgetProductName) {
        <button mat-menu-item
          (click)="onItemSelectionEvent($event, [{ type: 'trifold', doc }], widget, false)">Send To
        {{widgetProductName}}</button>
      }
      <button mat-menu-item
        [disabled]="!trifoldDetail.deleteFile"
      (click)="onItemFileEvent($event, 'trifold', doc, deleteFile, false)">Delete</button>
    </ng-template>
  </mat-menu>
</ng-template>
